module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "pg22lev1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Speedy chorizo and chickpea stew",
      "src": "images/f0022-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("One of the great things about tapas is that they can be whipped up in a flash. This speedy little stew is at home on a table laden with a selection of tapas, or served as a tasty meal for two that can be ready in minutes.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0023-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Serves 4 to 6 as a starter or 2 as a main")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Preparation time: 10 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Cooking time: 20 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("8 green onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tbsp olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tbsp finely chopped fresh rosemary leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tsp smoked sweet paprika")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("one 15-oz can chickpeas, drained and rinsed")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("2 chorizo sausages")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("2 tbsp sherry vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("one 15-oz can tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("sea salt and freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Chop the green onions into rounds, separating the white and green parts. Put the oil into a large frying pan over high heat. Add the white parts of the green onions, the rosemary, smoked paprika, and chickpeas to the pan and fry for 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Slice the chorizo into "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("8")]), _vm._v("-in-thick rounds, add to the pan, and cook for 2 minutes. Add the sherry vinegar, turn down the heat, and cook gently, uncovered, stirring occasionally, for 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Add the tomatoes and cook for 10 minutes. Taste for salt and pepper and adjust if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Finish the stew with the green tops of the green onions, sprinkling them over just before serving.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0022-02.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25571603","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11-chapter05.vue
// module id = 87
// module chunks = 0